import { crowdsaleModel } from 'entities/crowdsale';
import { giveawayModel } from 'entities/giveaway';
import { packagesModel } from 'entities/mine-package';
import { modalModel } from 'entities/modal';
import { reducer as paymentReducer } from 'entities/payment/model';
import { referrerModel } from 'entities/referrer';
import { userModel } from 'entities/user';
import { uiReducer } from 'shared';

export default {
  ui: uiReducer,
  modal: modalModel.reducer,
  user: userModel.reducer,
  crowdsale: crowdsaleModel.reducer,
  giveaway: giveawayModel.reducer,
  packages: packagesModel.reducer,
  payment: paymentReducer,
  referrer: referrerModel.reducer,
};
